interface Props {
  error: Error;
  resetErrorBoundary: () => void;
}

export default function ErrorHandler({}: Props) {
  return <div>Tentar novamente</div>;
}
